import React from "react";
import { useTranslation } from 'next-i18next';
import Image from "next/image";
import { useInView } from "react-intersection-observer";
import { ArrowLeft } from "assets/vectors";
import { Button } from "components/button";
import useHelper from "helpers";
import { Card, CardsWrapper } from "styles/cards";
import { ParagraphText, TextHeadingThree, Underlined } from "styles/typography";
import { ProductFeaturesWrapper } from "./product-features.styles";
import { ProductFeaturesList } from "./product-features.utils";

const ProductFeatures = () => {
   const { handleCta } = useHelper();
   const { t } = useTranslation('common');
   const { ref, inView } = useInView();
   const productFeaturesList = ProductFeaturesList();
   return (
      <ProductFeaturesWrapper>
         <div>
            <Underlined className="open-text-animation">{t('prod-feature-title')}</Underlined>
            <ParagraphText mw="340" style={{ fontSize: 28, lineHeight: 2 }}>
               {t('prod-feature-description', { Metricks: 'Metricks' })}
            </ParagraphText>

            <br />
            <br />

            <Button variant="primary" onClick={handleCta}>
               {t('start-cta-text')} <ArrowLeft />
            </Button>
         </div>

         <CardsWrapper col={2} gap={2.5} ref={ref}>
            {productFeaturesList.map((item) => (
               <Card key={item.id} className={inView ? "scale-up-animation" : ""}>
                  {/* <IconWrapper
                     style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: 50,
                        marginBottom: 20,
                     }}
                  > */}
                  <Image src={item.icon} width={58} height={58} alt={item.title} />
                  <TextHeadingThree>{item.title}</TextHeadingThree>
                  <ParagraphText>{item.description}</ParagraphText>
               </Card>
            ))}
         </CardsWrapper>
      </ProductFeaturesWrapper>
   );
};

export { ProductFeatures };
